/**
 * @fileoverview Javascript for enhanced lists to use
 */
goog.provide('yext.storm.enhancedlists');

/**
 * Bind various UI effects to user radio selection on list creation page
 */
goog.require('yext');
goog.require('yext.dialog');
goog.require('yext.locations.i18n');
/** @suppress {extraRequire} */
goog.require('yext.plugins.locationPicker');
/** @suppress {extraRequire} */
goog.require('yext.storm.FolderTree');
goog.require('yext.storm.routesDEPRECATED');
/** @suppress {extraRequire} */
goog.require('yext.plugins.ContextualHelpText');
goog.require('yext.ui.components.entitypicker.EntityPickerController');
goog.require('yext.ui.components.entitypicker.container.itemtypes');

goog.require('proto.searchfilters.CompoundEntitySearchFilter');
goog.require('proto.searchfilters.EntitySearchFilter');
goog.require('proto.searchfilters.SearchFilter');

yext.storm.enhancedlists.bindRadioSelection = function(formId) {
  var formSelector = 'form' + formId;
  $(formSelector + ' input:radio').click(function() {
    if ($(this).hasClass('select-folder')
        && $(formSelector + ' .enhancedlists-association-folder-container')
          .find('.dynatree-container').length === 0) {
      yext.storm.enhancedlists.setupTree(formSelector);
      $(formSelector + ' .enhancedlists-association-location-select').hide();
    } else if ($(this).hasClass('select-folder')) {
      $(formSelector + ' .enhancedlists-association-folder-container').show();
      $(formSelector + ' .enhancedlists-association-location-select').hide();
    } else if ($(this).hasClass('select-location')) {
      $(formSelector + ' .enhancedlists-association-folder-container').hide();
      $(formSelector + ' .enhancedlists-association-location-select').show();
    } else {
      $(formSelector + ' .enhancedlists-association-location-select').hide();
      $(formSelector + ' .enhancedlists-association-folder-container').hide();
    }
  });
};

const getLocaleCompoundFilter = localeCode => {
  const CompoundEntitySearchFilter = goog.module.get('proto.searchfilters.CompoundEntitySearchFilter');
  const EntitySearchFilter = goog.module.get('proto.searchfilters.EntitySearchFilter');
  const SearchFilter = goog.module.get('proto.searchfilters.SearchFilter');

  const StringList = SearchFilter.StringList;
  const localeStringListFilter = new StringList();
  localeStringListFilter.setType(StringList.Type.INCLUDES);
  localeStringListFilter.addCode(localeCode);
  const entityFilter = new EntitySearchFilter();
  entityFilter.addLocaleCodes(localeStringListFilter);
  const compoundSearchFilter = new CompoundEntitySearchFilter();
  compoundSearchFilter.setFilter(entityFilter);
  return compoundSearchFilter;
};

/**
 * Binds UEP with the permissions to check on and localeCode to filter entities to
 * @param {string} localeCode the locale to filter the location search with
 */
yext.storm.enhancedlists.bindLocationSearcher = function(localeCode) {
  const {ItemTypes} = goog.module.get('yext.ui.components.entitypicker.container.itemtypes');
  const {EntityPickerController: EntityPicker} = goog.module.get('yext.ui.components.entitypicker.EntityPickerController');
  const permissions = document.getElementsByClassName('js-location-search-permissions')[0];

  const options = {
    asFilter: false,
    allowedItems: [ItemTypes.ENTITIES, ItemTypes.FOLDERS],
    allowedSelectAllItems: [ItemTypes.ENTITIES],
    allowEntityTypeSelection: false,
    alternatePermissions: [permissions.value.split(',')],
    entityTypes: getDataFromElements('js-allowed-type-ids'),
    onSelect: onEntitySelect,
    compoundSearchFilter: getLocaleCompoundFilter(localeCode),
  };
  var initialEntityIds = getDataFromElements('js-entity-ids');
  if (initialEntityIds.length) {
    options.initialSelection = {
      'entities': initialEntityIds,
    };
  }
  ReactDOM.render(
    React.createElement(EntityPicker, options, null),
    goog.dom.getRequiredElementByClass('js-location-association-uep'));
};

/**
 * Gets data from the DOM given the class name to get data from
 * @param {string} the class name to return data for
 * @return {Array} the integer data from those elements
 */
const getDataFromElements = function(className) {
  var elements = document.getElementsByClassName(className);
  if (!elements) {
    return [];
  }
  var elementData = [];
  for (let element of elements) {
    if (element.value !== '') {
      elementData.push(parseInt(element.value));
    }
  }
  return elementData;
};

/**
 * Callback function for when a selection is made in the UEPv2
 * @param {Object} selection an object containing selected entities
 */
const onEntitySelect = function(selection) {
  const {ItemTypes} = goog.module.get('yext.ui.components.entitypicker.container.itemtypes');
  var forLocationType = document.getElementsByClassName('js-for-location-type')[0];
  var entitySelectWrap = document.getElementsByClassName('js-entity-select-wrap')[0];

  // have to make these HTMLCollections into static lists so we can remove iteratively
  var entityIdInputs = [...document.getElementsByClassName('js-entity-ids')];
  var folderIdInputs = [...document.getElementsByClassName('js-folder-ids')];

  entityIdInputs.forEach(input => input.remove());
  folderIdInputs.forEach(input => input.remove());

  // enable the select button because the user has made a change
  var selectButton = document.getElementById('save-button');
  if (selectButton) {
    selectButton.classList.remove('disabled');
    selectButton.classList.add('enabled');
  }
  var saveButton = document.getElementById('list-save-button');
  if (saveButton) {
    saveButton.classList.remove('disabled');
    saveButton.classList.add('enabled');
  }

  // remove the no selection text. We will add it later if the user really has no entities selected
  var noSelectionText = document.getElementById('no-selection-message');
  if (noSelectionText) {
    noSelectionText.style.display = 'none';
  }

  if (selection.allSelected === ItemTypes.ENTITIES) {
    forLocationType.value = 'ALL';
  } else if (selection.entities.length !== 0) {
    selection.entities.forEach(entity => {
      var entityIdClone = document.createElement('input');
      entityIdClone.type = 'hidden';
      entityIdClone.name = 'locationId';
      entityIdClone.className = 'js-entity-ids';
      entityIdClone.value = entity.id;
      entitySelectWrap.appendChild(entityIdClone);
    });
    forLocationType.value = 'LOCATION';
  } else if (selection.folders.length !== 0) {
    selection.folders.forEach(folder => {
      var folderIdClone = document.createElement('input');
      folderIdClone.type = 'hidden';
      folderIdClone.name = 'folderId';
      folderIdClone.className = 'js-folder-ids';
      folderIdClone.value = folder.id;
      entitySelectWrap.appendChild(folderIdClone);
    });
    forLocationType.value = 'FOLDER';
  } else {
    forLocationType.value = 'NONE';
    noSelectionText.style.display = 'block';
  }
};

/**
 * Capitalize the given string.
 */
yext.storm.enhancedlists.capitalize = function(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

/**
 * Method to setup a basic folder selection tree for the list creation page assignment section
 */
yext.storm.enhancedlists.setupTree = function(formSelector) {
  var $treeContainer = $(formSelector + ' .enhancedlists-association-folder-container');
  var idPrefix = 'enhancedlists-tree-id-';
  $treeContainer.simpleFolderTree({
    'title': yext.msg('Enhanced Lists Location Association Folder Selection Tree'),
    'topLevelFolders': window.topLevelFolders,
    'idPrefix': idPrefix,
    'onActivate': function(node) {
      $('input[name="folderId"]').val(node.data.key).trigger('change');
    },
  });

  // Hide root folder, since it should not be selectable
  $treeContainer.find('#' + idPrefix + '0 .dynatree-node').hide();
};

/**
 * Handles showing and submitting confirmation dialogs that appear when associating lists to locations.
 *
 * @param {!jQuery} $dialog The dialog object to show
 * @param {string} title title of the dialog
 * @param {function()} submitFunction callback function on submit
 */
yext.storm.enhancedlists.showAssociationConfirmationDialog = function($dialog, title, submitFunction) {
  if ($dialog.data('ui-dialog')) {
    $dialog.dialog('destroy');
  }

  var cancelFn = function() {
    yext.dialog.hideProgressDialog();
    $dialog.dialog('close');
    return false;
  };

  $dialog.find('.cancel')
    .unbind('click')
    .click(cancelFn);
  $dialog.find('.primary')
    .unbind('click')
    .click(function() {
      $dialog.dialog('close');
      submitFunction();
      return false;
    });
  $dialog.dialog(
    {
      autoOpen: true,
      modal: true,
      draggable: false,
      resizable: false,
      autofocus: '.primary',
      title: title,
      width: 355,
      create: function() {
        $(this).closest('div.ui-dialog')
          .find('.ui-dialog-titlebar-close')
          .click(cancelFn);
        return false;
      },
    },
  );
};

/**
 * Wrapper around create list/edit list requests to handle the location association flow
 */
yext.storm.enhancedlists.handleListAssociationSubmit = function(
  serializedFormData,
  successHandler,
  errorHandler,
  url,
  params,
  progress) {
  var ajaxOptions = {
    type: 'POST',
    data: serializedFormData + '&' + (params ? $.param(params) : ''),
    cache: false,
    success: function(result) {
      if (result.jobKey) {
        if (!progress || result.progress > progress) {
          yext.dialog.hideProgressDialog();
          // TRANSLATORS: The argument is a number
          // EXAMPLE: Generating file (58%)...
          yext.dialog.showProgressDialog(yext.msg('Associating ({0}%)...', result.progress));
        }

        // Make the call again with cache key and timeout
        params.jobKey = result.jobKey;
        setTimeout(function() {
          yext.storm.enhancedlists.handleListAssociationSubmit(
            serializedFormData,
            successHandler,
            errorHandler,
            url,
            params,
            progress);
        }, 2000);
      } else if (result.numLocationsToAssociate) {
        // Extra confirmation when associating with all locations
        var entityCount = yext.msgn('1 entity', '{0} entities', result.numLocationsToAssociate);
        $('.js-associate-all-dialog').find('.js-locations-to-associate').html(entityCount);
        yext.storm.enhancedlists.showAssociationConfirmationDialog(
          $('.js-associate-all-dialog'),
          yext.msg('Confirm association'),
          function() {
            return yext.storm.enhancedlists.handleListAssociationSubmit(
              serializedFormData + '&confirmAssociateAll=true',
              successHandler,
              errorHandler,
              url,
              params);
          });
      } else if (result.someLocationsFull) {
        // Some entities are full, show confirm message to user
        yext.storm.enhancedlists.showAssociationConfirmationDialog(
          $('.js-some-locations-full-dialog'),
          // TRANSLATORS: Some entities have as many lists associated with them as is allowed.
          yext.msg('Some entities are full'),
          function() {
            return yext.storm.enhancedlists.handleListAssociationSubmit(
              serializedFormData + '&skipSomeLocationsFullCheck=true',
              successHandler,
              errorHandler,
              url,
              params);
          });
      } else {
        successHandler(result);
      }
    },
    error: function(result) {
      errorHandler(result);
    },
  };
  if (url) {
    ajaxOptions.url = url;
  }

  $.ajax(ajaxOptions);
};

/**
 * Wrapper around change list currency and language
 */
yext.storm.enhancedlists.handleChangeListSubmit = function(
  serializedFormData,
  successHandler,
  errorHandler,
  url,
  params) {
  var ajaxOptions = {
    type: 'POST',
    data: serializedFormData + '&' + (params ? $.param(params) : ''),
    cache: false,
    success: successHandler,
    error: errorHandler,
  };
  if (url) {
    ajaxOptions.url = url;
  }

  $.ajax(ajaxOptions);
};


/**
 * Adds contextual tooltip spreadsheet upload information
 */
yext.storm.enhancedlists.bindSpreadsheetUploadContextualHelp = function() {
  var single; var bulk;
  switch ($('input[name="type"]').val()) {
    case 'Menu':
      single = yext.msg('If you have a spreadsheet containing your menu items, you can upload it to populate your menu. Note that this will replace all menu items you already have in your menu.');
      bulk = yext.msg('If you have a spreadsheet containing your menus, you can upload it to populate your menus. Note that this will replace all menus you already have with the same name.');
      break;
    case 'ProductList':
      single = yext.msg('If you have a spreadsheet containing your products or services, you can upload it to populate your list. Note that this will replace all products or services you already have in your list.');
      bulk = yext.msg('If you have a spreadsheet containing your lists, you can upload it to populate your lists. Note that this will replace all lists you already have with the same name.');
      break;
    case 'Calendar':
      single = yext.msg('If you have a spreadsheet containing your events, you can upload it to populate your calendar. Note that this will replace all events you already have in your calendar.');
      bulk = yext.msg('If you have a spreadsheet containing your calendars, you can upload it to populate your calendars. Note that this will replace all calendars you already have with the same name.');
      break;
    case 'Bios':
      single = yext.msg('If you have a spreadsheet containing your bios, you can upload it to populate your list. Note that this will replace all bios you already have in your list.');
      bulk = yext.msg('If you have a spreadsheet containing your lists, you can upload it to populate your lists. Note that this will replace all lists you already have with the same name.');
      break;
  }
  window.contextualHelp['list-upload-spreadsheet-single'] = single;
  window.contextualHelp['list-upload-spreadsheet-bulk'] = bulk;
};

/**
 * Send delete to WidgetsStorm to delete the widgets associated with the given listIds
 * @param {number} businessId The business id associated with the lists and widgets
 * @param {string} listIds The listIds to delete as a comma separated list
 */
yext.storm.enhancedlists.deleteWidgets = function(businessId, listIds) {
  if (listIds.length > 0) {
    $.ajax({
      url: '/s/' + businessId + '/w/bulkDelete',
      dataType: 'json',
      type: 'POST',
      contentType: 'application/json',
      data: window.JSON.stringify({
        'listIds': listIds,
      }),
    });
  }
};

/**
 * Show dialog to delete lists
 */
yext.storm.enhancedlists.showDeleteListDialog = function(
  numLists,
  callback,
  text) {
  var $dialog = $('#delete-list-dialog');
  if ($dialog.data('ui-dialog')) {
    $dialog.dialog('destroy');
  }

  var title; var confirm;
  switch ($('input[name="type"]').val()) {
    case 'Menu':
      title = yext.msgn('Delete Menu', 'Delete Menus', numLists);
      confirm = yext.msgn('Delete menu', 'Delete menus', numLists);
      break;
    case 'ProductList':
    case 'Bios':
      title = yext.msgn('Delete List', 'Delete Lists', numLists);
      confirm = yext.msgn('Delete list', 'Delete lists', numLists);
      break;
    case 'Calendar':
      title = yext.msgn('Delete Calendar', 'Delete Calendars', numLists);
      confirm = yext.msgn('Delete calendar', 'Delete calendars', numLists);
      break;
  }

  $dialog.find('.cancel').unbind('click');
  $dialog.find('.cancel').click(function() {
    $dialog.dialog('close');
    return false;
  });

  $dialog.find('.primary span').text(confirm);
  $dialog.find('.primary').unbind('click');
  $dialog.find('.primary').click(callback);
  $dialog.find('.dialog-content-for-deletion').html(text);

  $dialog.dialog({
    autoOpen: true,
    modal: true,
    draggable: false,
    resizable: false,
    title: title,
    width: 355,
  });
};

yext.storm.enhancedlists.showExportDialog = function(type, listIds, listName, listCount, selectAll, isTemplate) {
  var $dialog = $('#export-lists-dialog');
  var title = '';
  var msg = '';
  if (listCount == 0) {
    title = yext.msg('Download template');
    switch ($('input[name="type"]').val()) {
      case 'Menu':
        msg = yext.msg('Download a menu template in the selected format');
        break;
      case 'ProductList':
        msg = yext.msg('Download a list template in the selected format');
        break;
      case 'Calendar':
        msg = yext.msg('Download a calendar template in the selected format');
        break;
      case 'Bios':
        msg = yext.msg('Download a list template in the selected format');
        break;
    }
  } else {
    if (listName) {
      // TRANSLATORS: The argument is the name of a list
      msg = yext.msg('Export "{0}" as a spreadsheet in the selected format:', listName);
    }
    switch ($('input[name="type"]').val()) {
      case 'Menu':
        if (!msg) {
          msg = yext.msgn(
            'Export this menu as a spreadsheet in the selected format:',
            'Export these {0} menus as a spreadsheet in the selected format:',
            listCount);
        }
        title = yext.msgn('Export menu', 'Export {0} menus', listCount);
        break;
      case 'ProductList':
        if (!msg) {
          msg = yext.msgn(
            'Export this list as a spreadsheet in the selected format:',
            'Export these {0} lists as a spreadsheet in the selected format:',
            listCount);
        }
        title = yext.msgn('Export list', 'Export {0} lists', listCount);
        break;
      case 'Calendar':
        if (!msg) {
          msg = yext.msgn(
            'Export this calendar as a spreadsheet in the selected format:',
            'Export these {0} calendars as a spreadsheet in the selected format:',
            listCount);
        }
        title = yext.msgn('Export calendar', 'Export {0} calendar', listCount);
        break;
      case 'Bios':
        if (!msg) {
          msg = yext.msgn(
            'Export this list as a spreadsheet in the selected format:',
            'Export these {0} lists as a spreadsheet in the selected format:',
            listCount);
        }
        title = yext.msgn('Export list', 'Export {0} lists', listCount);
        break;
    }
  }
  $dialog.find('.message').text(msg);

  var closeDialog = function() {
    $dialog.find('.export-format input[name=fileType][value=xls]');
    if ($dialog.data('ui-dialog')) {
      $dialog.dialog('destroy');
    }
  };

  var downloadFiles = function() {
    var fileType = $dialog.find('.export-format input[name=fileType]:checked').val();
    closeDialog();
    yext.storm.enhancedlists.downloadListsFile(type, listIds, selectAll, fileType, isTemplate);
    // prevent href="#" from updating the url
    return false;
  };

  $dialog.find('.primary').unbind('click');
  $dialog.find('.primary').click(downloadFiles);

  $dialog.find('.cancel').unbind('click');
  $dialog.find('.cancel').click(closeDialog);

  $dialog.dialog({
    autoOpen: true,
    modal: true,
    draggable: false,
    resizable: false,
    title: title,
    autofocus: '.primary',
    width: 355,
  });
};

yext.storm.enhancedlists.downloadListsFile = function(type, listIds, selectAll, fileType, isTemplate) {
  var downloadId;

  // Create a download id initially.
  var idParams = {
    'type': type,
    'ids': listIds,
    'exportAll': selectAll,
    'fileType': fileType,
    'isTemplate': isTemplate,
  };
  $.ajax({
    url: yext.storm.routesDEPRECATED.EnhancedLists.createDownloadId(idParams),
    type: 'GET',
    dataType: 'json',
    success: function(data) {
      if (data.downloadId) {
        downloadId = data.downloadId;
      } else {
        yext.dialog.showErrorDialog(yext.msg('Error initializing download.'));
      }
    },
    async: false,
  });

  if (downloadId) {
    var downloadParams = {'downloadId': downloadId};
    var latestProgress = -1;
    var keepChecking = function() {
      return true;
    };

    // Checking the status of the download.
    var getProgress = function(jqXHR, textStatus) {
      if ((jqXHR && jqXHR.status != 200) || !keepChecking()) {
        yext.dialog.hideProgressDialog();
        return;
      }
      setTimeout(function() {
        $.ajax({
          url: yext.storm.routesDEPRECATED.EnhancedLists.getDownloadStatus(downloadParams),
          type: 'GET',
          dataType: 'json',
          success: function(data) {
            if (data.percent == 100) {
              yext.dialog.showProgressDialog(yext.msg('Generating file (99%)...'));
              keepChecking = function() {
                return false;
              };
              // Once the file is actually there, go and get it.
              yext.storm.enhancedlists.downloadFile(downloadId);
            } else {
              var progress = data.percent;
              if (progress > latestProgress) {
                yext.dialog.hideProgressDialog();
                latestProgress = Math.min(99, progress);
                // TRANSLATORS: The argument is a number
                // EXAMPLE: Generating file (58%)...
                yext.dialog.showProgressDialog(yext.msg('Generating file ({0}%)...', latestProgress));
              }
            }
          },
          complete: getProgress,
        });
      }, 1000);
    };
    getProgress();

    // Actually generate the file. This may take a while for many lists.
    $.ajax({
      url: yext.storm.routesDEPRECATED.EnhancedLists.generateDownloadFile(downloadParams),
    }).fail(function() {
      window.showErrorDialog(yext.locations.i18n.msg.cantDownloadExport);
      keepChecking = function() {
        return false;
      };
    });
  }
};

yext.storm.enhancedlists.downloadFile = function(downloadId) {
  var params = {'downloadId': downloadId};
  var downloadUrl = yext.storm.routesDEPRECATED.EnhancedLists.renderDownloadFile(params);

  var $iframe = $('<iframe></iframe>');
  $iframe.attr('width', '1');
  $iframe.attr('height', '1');
  $iframe.attr('src', downloadUrl);
  $(document.body).append($iframe);
};

yext.storm.enhancedlists.bindSingleListExport = function() {
  $('.export-single-list').click(function() {
    var type = $('input[name="type"]').val();
    var listName = $('input[name="listName"]').val();
    var listIds = [$('input[name="listId"]').val()];
    yext.storm.enhancedlists.showExportDialog(
      type,
      listIds,
      listName,
      1 /* listCount */,
      false /* selectAll */,
      false /* isTemplate */);
  });
};

/**
 * Used to determine if we need to upload a file. Only do so if we have a file
 * and we are not cropping the images.
 */
yext.storm.enhancedlists.needsFileUpload = function(croppedImage, file) {
  return !croppedImage && !!file;
};

yext.storm.enhancedlists.bindDownloadTemplate = function() {
  $('.download-list-template').click(function() {
    var type = $('input[name="type"]').val();
    yext.storm.enhancedlists.showExportDialog(
      type,
      [] /* listIds */,
      null /* listName */,
      0 /* listCount */,
      false /* selectAll */,
      true /* isTemplate */);
  });
};
goog.exportSymbol('yext.storm.enhancedlists.bindDownloadTemplate', yext.storm.enhancedlists.bindDownloadTemplate);
